<!--联系-->
<template>
  <div class="main">
    <div class="header">
      <Header
        @toLocation="toLocation"
        :headerMenuSelectedKey="headerMenuSelectedKey"
        :shrinkMenuSelectedKey="subMenuSelectedKey"/>
    </div>
    <!--    banner图-->
    <div class="banner">
      <div class="item">
        <img :src="dataList[currentIndex]">
      </div>
      <div class="page" v-if="this.dataList.length > 1">
        <ul>
          <ul>
            <li @click="gotoPrev" class="pre">&lt;</li>
            <li @click="gotoNext" class="next">&gt;</li>
          </ul>
        </ul>
      </div>
    </div>
    <!--    内容-->
    <div class="content">
      <div class="about-us">
        <h1>关于我们</h1>
        <div class="line">
          <div class="line-left"></div>
          <div class="line-right"></div>
        </div>
        <div class="contact-img">
          <div class="contact-img-tel">
            <img src="static/image/icon/tel.png" class="img-icon"/>
            <h2>Contact Phone</h2>
            <p>156 1886 7230</p>
          </div>
          <div class="contact-img-tel">
            <img src="static/image/icon/email.png" class="img-icon"/>
            <h2>Our Contact Email</h2>
            <p>chris.li@fudaicy.com</p>
          </div>
          <div class="contact-img-tel">
            <img src="static/image/icon/address.png" class="img-icon"/>
            <h2>Our Location</h2>
            <p>Shanghai, China</p>
          </div>
        </div>
      </div>
    </div>
    <!--    企业微信-->
    <div class="enterpriseWechat">
      <EnterpriseWechat/>
    </div>
    <div class="footer">
    <Footer/>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import EnterpriseWechat from "../components/EnterpriseWechat";

export default {
  components: {Header, Footer, EnterpriseWechat},
  data() {
    return {
      headerMenuSelectedKey: 'contact',//todo
      subMenuSelectedKey: '',//todo
      dataList: ["static/image/contact/banner1.jpg", "static/image/contact/banner2.jpg",],
      currentIndex: 0,   //默认显示图片
    };
  },
  watch: {},
  mounted() {
    document.title = "联系";
    this.gotoPage()
  },
  methods: {
    toLocation(location) {
      this.subMenuSelectedKey = location
    },
    gotoPrev() {
      this.currentIndex--
    },
    gotoNext() {
      this.currentIndex++;
      if (this.currentIndex == this.dataList.length) {
        this.currentIndex = 0;
      }
    },
    gotoPage() {
      setInterval(() => {
        this.gotoNext()
      }, 3000)
    },
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.main {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(249, 249, 249, 1);
}

.header {
  width: 1920px;
  height: 60px;
}

.enterpriseWechat {
  position: fixed;
  top: 45%;
  right: 0;
}
.banner {
  width: 100%;
  margin: 0 auto;
  position: relative;
}

.banner img {
  width: 100%;
  display: block;
}

.banner .page {
  /*background: rgba(0, 0, 0, .5);*/
  color: #ffffff;
  letter-spacing: 20px;
  position: absolute;
  right: 0;
  bottom: 50%;
  width: 100%;
}

.banner .page ul {
  display: flex;
  justify-content: center;
  align-content: center;
}
.pre {
  position: absolute;
  left: 10px;
  font-size: 30px;
}
.next {
  position: absolute;
  right: 0px;
  font-size: 30px;
}

.content {
  width: 1400px;
  height: 800px;
}
.about-us {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 50px;
}

h1 {
  color: #D1121C;
  font-size: 34px;
  text-align: center;
}
.line {
  margin-top: 20px;
}

.line-left {
  width: 37px;
  height: 8px;
  background: #D1121C;
  border-radius: 10px;
  float: left;
}

.line-right {
  width: 119px;
  height: 8px;
  background: #D1121C;
  border-radius: 10px;
  float: left;
  margin-left: 10px;
}
.contact-img {
  width: 1400px;
  height: 300px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 50px;
}
.contact-img-tel {
  width: 32%;
  height: 300px;
  background: #ffffff;
  border-radius: 10px;
}
.img-icon {
  width: 80px;
  height: 80px;
  margin: 30px 35px;
}
.contact-img-tel h2 {
  font-weight: bold;
  font-size: 28px;
  color: #000000;
  margin: 20px 35px;
}
.contact-img-tel p {
  font-size: 20px;
  color: #000000;
  margin: 20px 35px;
}
.footer {
  height: 189px;
  width: 1920px;
  overflow: hidden;
  position: relative;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Contact.vue